import React from 'react';
import PropTypes from 'prop-types';
import styles from '../styles/ConfirmationDialog.module.css';

const ConfirmationDialog = ({
  title,
  message,
  details,
  confirmLabel,
  cancelLabel,
  onConfirm,
  onCancel
}) => {
  return (
    <div className={styles.overlay}>
      <div className={styles.dialog}>
        <h2 className={styles.title}>{title}</h2>
        <p className={styles.message}>{message}</p>
        <div className={styles.details}>
          {details.map((detail) => (
            <p key={detail} className={styles.detail}>{detail}</p>
          ))}
        </div>
        <div className={styles.buttons}>
          <button
            className={`${styles.button} ${styles.confirm}`}
            onClick={onConfirm}
          >
            {confirmLabel}
          </button>
          <button
            className={`${styles.button} ${styles.cancel}`}
            onClick={onCancel}
          >
            {cancelLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

ConfirmationDialog.propTypes = {
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  details: PropTypes.arrayOf(PropTypes.string).isRequired,
  confirmLabel: PropTypes.string.isRequired,
  cancelLabel: PropTypes.string.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired
};

export default ConfirmationDialog;
